import { withChartLayout } from 'components/common';
import PatientTeaching from 'components/features/chart/patient-teaching/PatientTeaching';

const PatientTeachingPage = withChartLayout('Patient Teaching')(PatientTeaching);
export default PatientTeachingPage;
